export function getInvoiceDescription(invoice) {
  if (!invoice) {
    return null;
  }
  if (invoice?.lineItems?.length) {
    const lineItemsSorted = invoice.lineItems.filter((li) => li.amount > 0).sort((a, b) => b.amount - a.amount);
    const concatedLineItems = lineItemsSorted.map((li) => `${li.description}`).join(' + ');
    return concatedLineItems;
  }
  return invoice.product;
}
